<template>
  <div class="outer">
    <div class="inner">
      <h4>{{title}}</h4>
      <br>
        <fulfilling-bouncing-circle-spinner
          :animation-duration="4000"
          :size="80"
          color="#419be0"
        />
    </div>
  </div>
</template>

<script>
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'

export default {
  props: {
      title: String
  },
  components: {
      FulfillingBouncingCircleSpinner
  },
  data() {
    return {
      animate: true
    }
  }
}
</script>

<style scoped>
.content{
  display: flex;
  justify-content: center;
  align-items: center;
}

.inner {
	position: absolute;
	top: 25%;
	left: 50%;
	transform: translate(-50%, -50%);
}
</style>
